import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FormHelperModule } from '../shared/form/form-hepler.module';
import { ImageUploadModule, SharedModule } from '../shared/shared.module';
import { ChangePasswordComponent } from './component/change-password/change-password.component';
import { SignupComponent } from './component/signup/signup.component';
import { UserFooterComponent } from './component/user-footer/user-footer.component';
import { UserHeaderComponent } from './component/user-header/user-header.component';
import { UserLeftSideBarComponent } from './component/user-left-side-bar/user-left-side-bar.component';
import { UserRightSideBarComponent } from './component/user-right-side-bar/user-right-side-bar.component';
import { SearchModalComponent } from './component/search-modal/search-modal.component';


@NgModule({
  declarations: [UserHeaderComponent,
    UserFooterComponent,
    UserRightSideBarComponent,
    UserLeftSideBarComponent,
    ChangePasswordComponent,
    SignupComponent,
    SearchModalComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    ImageUploadModule,
    FormHelperModule,
    SharedModule
  ],
  exports: [UserFooterComponent, UserHeaderComponent, UserRightSideBarComponent, UserLeftSideBarComponent]
})
export class CoreModule { }
